export default __webpack_public_path__ + "assets/img/MaterialIcons-Regular.5e7382c63da0098d634a356ff441614e.ttf";